import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-brower",
  "use": "icon-brower-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-brower\"><defs><style type=\"text/css\"></style></defs><path d=\"M859 79.27H165a90 90 0 0 0-90 90v694a90 90 0 0 0 90 90h694a90 90 0 0 0 90-90v-694a90 90 0 0 0-90-90z m-693 60h694a30 30 0 0 1 30 30v145H136v-145a30 30 0 0 1 30-30z m693 754H165a30 30 0 0 1-30-30v-489h754v489a30 30 0 0 1-30 30z\" fill=\"#878A94\" p-id=\"14139\" /><path d=\"M223.47 227.98m-50 0a50 50 0 1 0 100 0 50 50 0 1 0-100 0Z\" fill=\"#878A94\" p-id=\"14140\" /><path d=\"M353.08 227.98m-50 0a50 50 0 1 0 100 0 50 50 0 1 0-100 0Z\" fill=\"#878A94\" p-id=\"14141\" /><path d=\"M482.69 227.98m-50 0a50 50 0 1 0 100 0 50 50 0 1 0-100 0Z\" fill=\"#878A94\" p-id=\"14142\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/brower.svg
// module id = 6Yom
// module chunks = 34